import api from './api';

export const AFFILIATE_SET = 'AFFILIATE_SET';

export default function reducer(state = {}, {type, payload}) {
  switch (type) {
    case AFFILIATE_SET:
      return {
        ...state,
        [payload.slug]: payload.affiliate
      };
    default:
      return state;
  }
}

export function setAffiliate(slug, affiliate) {
  return {type: AFFILIATE_SET, payload: {slug, affiliate}};
}

export function fetchAffiliate(slug) {
  return dispatch => {
    dispatch(setAffiliate(slug, null));

    return dispatch(api.get(`affiliates/by-slug/${slug}`, undefined, {cache: 'default'}))
      .then(affiliateResponse => dispatch(setAffiliate(slug, affiliateResponse.content)))
      .catch(err => {
        if (err.status === 404) {
          dispatch(setAffiliate(slug, false));
        }

        throw err;
      });
  }
}



// WEBPACK FOOTER //
// ./ducks/affiliate.js